/* Mobile product gallery progress bar.
   Injects a theme-native .flickity-progress element after the thumbnail strip
   and drives its width from the strip's horizontal scroll position.
   Mobile only (<=767px). No dependency on Flickity or jQuery.

   Click-to-switch-main-image and active-thumb sync are handled by the theme's
   own product-slider component; this file only adds the progress indicator. */
(function () {
  if (window.__joyeeMobileGalleryInit) return;
  window.__joyeeMobileGalleryInit = true;

  var MOBILE = '(max-width: 767px)';

  function initGallery(gallery) {
    var strip = gallery.querySelector('.product-thumbnail-container');
    if (!strip) return;

    var shadow = strip.closest('scroll-shadow') || strip.parentElement;

    // Create the progress bar once per gallery
    var progress = gallery.querySelector('.joyee-thumb-progress');
    if (!progress) {
      progress = document.createElement('div');
      progress.className = 'flickity-progress joyee-thumb-progress';
      var bar = document.createElement('div');
      bar.className = 'flickity-progress--bar';
      progress.appendChild(bar);
      // Place directly after the scrolling strip, inside scroll-shadow
      shadow.appendChild(progress);
    }
    var barEl = progress.querySelector('.flickity-progress--bar');

    function update() {
      var max = strip.scrollWidth - strip.clientWidth;
      var pct = max > 0 ? (strip.scrollLeft / max) * 100 : 0;
      barEl.style.width = pct + '%';
    }

    function syncVisibility() {
      var scrollable = strip.scrollWidth - strip.clientWidth > 2;
      var onMobile = window.matchMedia(MOBILE).matches;
      // Hide the bar when there's nothing to scroll or we're on desktop
      progress.style.display = (scrollable && onMobile) ? 'block' : 'none';
      if (progress.style.display === 'block') update();
    }

    if (!strip.__joyeeBound) {
      strip.__joyeeBound = true;
      strip.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', syncVisibility, { passive: true });
      // Variant selection can add/remove thumbnails → recalc when the strip mutates
      if ('MutationObserver' in window) {
        new MutationObserver(syncVisibility).observe(strip, {
          childList: true,
          subtree: false,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }
    }

    syncVisibility();
  }

  function initAll() {
    document.querySelectorAll('.product-gallery-container').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: re-init when the product section reloads
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();